
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/avtor/letter/[letterSign]",
      function () {
        return require("private-next-pages/avtor/letter/[letterSign]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/avtor/letter/[letterSign]"])
      });
    }
  